// extracted by mini-css-extract-plugin
export default {"publishedDate":"PublishedDate-module--publishedDate--20485","left":"PublishedDate-module--left--294df","center":"PublishedDate-module--center--c5bca"};